import { ScmInstance } from "@/instance/axios";
import { createMutationKeys, createQueryKeys } from "@lukemorales/query-key-factory";
import {
  ScmApiVehiclesFindPostRequest,
  ScmApiVehiclesGetRequest,
  ScmApiVehiclesPostRequest,
  ScmApiVehiclesVehicleIdDeleteRequest,
  ScmApiVehiclesVehicleIdGetRequest,
  ScmApiVehiclesVehicleIdPutRequest,
} from "@sizlcorp/sizl-api-document/dist/models";

export const vehicles = createQueryKeys("vehicles", {
  all: null,
  get: (params: ScmApiVehiclesGetRequest) => {
    const queryParams = {
      ...params,
      query: JSON.stringify({ $and: params?.query }),
      sort: params.sort?.length ? params.sort : "-id",
    };

    return {
      queryKey: [queryParams, JSON.stringify(queryParams)],
      queryFn: () => ScmInstance.vehiclesGet(queryParams),
    };
  },
  detail: (params: ScmApiVehiclesVehicleIdGetRequest) => ({
    queryKey: [params.vehicleId],
    queryFn: () => ScmInstance.vehiclesVehicleIdGet(params),
  }),
  find: (params: ScmApiVehiclesFindPostRequest) => {
    const query = { ...params };
    if (Array.isArray(params.query.$and) && params.query.$and.length > 0) {
      query["query"] = JSON.stringify(params.query);
    }
    if (params.search) {
      query["search"] = params.search;
      query["searchFields"] = params.searchFields;
    }
    return {
      queryKey: [query, JSON.stringify(query.query)],
      queryFn: () => ScmInstance.vehiclesFindPost(query),
    };
  },
});

export const mutateVehicles = createMutationKeys("vehicles", {
  create: (params: ScmApiVehiclesPostRequest) => ({
    mutationKey: [params.vehiclesGetRequest],
    mutationFn: () => ScmInstance.vehiclesPost(params),
  }),
  update: (params: ScmApiVehiclesVehicleIdPutRequest) => ({
    mutationKey: [params],
    mutationFn: () => ScmInstance.vehiclesVehicleIdPut(params),
  }),
  delete: (params: ScmApiVehiclesVehicleIdDeleteRequest) => ({
    mutationKey: [params],
    mutationFn: () => ScmInstance.vehiclesVehicleIdDelete(params),
  }),
});
